import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../common/components/Icon/Icon";

interface OrderAppointmentCardProps {
  appointmentData?: {
    date: string;
    time: string;
  };
}

const OrderAppointmentCard: React.FC<OrderAppointmentCardProps> = ({
  appointmentData,
}) => {
  const { t, i18n } = useTranslation();

  if (!appointmentData) return null;

  const formattedDate = new Date(appointmentData.date).toLocaleDateString(
    i18n.language === "tr" ? "tr-TR" : "en-US",
    { weekday: "long", year: "numeric", month: "long", day: "numeric" },
  );

  return (
    <div className="order-page__details-card order-page__details-card--appointment">
      <h3>
        <Icon iconName="calendar" className="icon--stroke-thick" />
        {t("orderPage.appointment.title", "Appointment Details")}
      </h3>
      <div className="order-page__appointment-content">
        <p>
          <strong>{t("orderPage.appointment.date", "Date")}:</strong>{" "}
          {formattedDate}
        </p>
        <p>
          <strong>{t("orderPage.appointment.time", "Time")}:</strong>{" "}
          {appointmentData.time}
        </p>
      </div>
    </div>
  );
};

export default OrderAppointmentCard;
